import { render, staticRenderFns } from "./OrderActionsDelete.vue?vue&type=template&id=3c73630e&lang=pug&"
import script from "./OrderActionsDelete.vue?vue&type=script&lang=js&"
export * from "./OrderActionsDelete.vue?vue&type=script&lang=js&"
import style0 from "./OrderActionsDelete.vue?vue&type=style&index=0&id=3c73630e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports